import {CssBaseline} from "@mui/material"
import React, {StrictMode} from "react"
import ReactDOM from "react-dom/client"
import {InstitutionAutocomplete} from "./InstitutionAutocomplete"
import {InstitutionAutocompleteApi} from "./InstitutionAutocompleteApi"

[...document.getElementsByClassName("institution-autocomplete")]
    .forEach(function (element) {
        return ReactDOM.createRoot(element)
            .render(<StrictMode>
                <CssBaseline />
                <InstitutionAutocompleteApi relativePath={ element.dataset.relativePath }>
                    <InstitutionAutocomplete
                        name={ element.id }
                        authorizedUserId={ element.dataset.authorizedUserId }
                        authorizedUserIdError={ element.dataset.authorizedUserIdError }
                    />
                </InstitutionAutocompleteApi>
            </StrictMode>)
    })

